// extracted by mini-css-extract-plugin
export default {"keyboard_key":"KeyboardKey_keyboard_key__EhXm5","active":"KeyboardKey_active__zrvVA"};